import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import {
  getTopRatedIndexContentPath,
  getTopRatedThemeContentPath,
} from 'site-modules/shared/utils/top-rated/content-path';
import { get } from 'lodash-es';

export function rendererTopRatedIndex(Page) {
  function TopRatedIndexUI({
    content = null,
    isDefaultYear = false,
    themeContent = null,
    isMobile = false,
    pathname = null,
    ...restProps
  }) {
    if (!content) {
      return null;
    }

    return (
      <Page
        content={content}
        {...restProps}
        isDefaultYear={isDefaultYear}
        themeContent={themeContent}
        isMobile={isMobile}
        pathname={pathname}
      />
    );
  }

  TopRatedIndexUI.propTypes = {
    year: PropTypes.string.isRequired,
    isDefaultYear: PropTypes.bool,
    content: CmsEntities.Content,
    themeContent: CmsEntities.Content,
    isMobile: PropTypes.bool,
    pathname: PropTypes.string,
  };

  const mapStateToProps = state => ({
    isMobile: state.mobile,
    pathname: get(state, 'pageContext.location.pathname'),
  });

  return connect(mapStateToProps)(
    connectToModel(TopRatedIndexUI, {
      content: bindToContent(({ year }) => getTopRatedIndexContentPath(year)),
      themeContent: bindToContent(({ year }) => getTopRatedThemeContentPath(year)),
    })
  );
}
